import React from 'react';
function Terms() {
  return (
    <div style={{ padding: '60px', maxWidth: '800px', margin: '0 auto', fontFamily: 'DM Sans', color: '#fff' }}>
      <h1>Terms of Service</h1>
      <p>By using CommentFlow, you agree to use the service in compliance with Instagram and Facebook's platform policies. You are responsible for the content of automated replies sent through your account.</p>
      <p>Contact: anshjaiswal9545@gmail.com</p>
    </div>
  );
}
export default Terms;